import * as React from 'react';
import { Responsive, UIHeading4 } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';

import { useApplicationContext } from '../../utils/applicationContext';
import { getActiveRatingFiltersValues, getAvailableTags } from '../../selectors/filters';
import { toggleTagFilter } from '../../actions/filters';
import { loadReviews } from '../../actions/reviews/loadReviews';
import { getObjectRating } from '../../selectors/objectInfo';
import { tracFilterAnalyticClick } from './analytics/reactionAnalytic';
import { RatingTagItem, RatingTagsSlider } from '../../components/RatingsTags';
import { getActiveSortValue } from '../../selectors/sort';
import { getIsReviewTab } from '../../selectors/tabs';
import { TThunkDispatch } from '../../types/redux';

export const RatingsTagsContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { custom } = useApplicationContext();

  const tags = useSelector(getAvailableTags);
  const siteType = custom.deviceType;
  const rating = useSelector(getObjectRating);
  const activeSort = useSelector(getActiveSortValue);
  const reviewRate = useSelector(getActiveRatingFiltersValues);
  const isReview = useSelector(getIsReviewTab);

  const onClick = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType,
        extra: {
          rating,
          filter_rating: reviewRate,
          filter_sort: activeSort,
          filter_tag: event.target.value,
        },
      };
      tracFilterAnalyticClick({ page });
      dispatch(toggleTagFilter(event.target.value));
      dispatch(loadReviews());
    },
    [toggleTagFilter, loadReviews, dispatch, reviewRate, siteType],
  );

  if (!isReview) {
    return null;
  }

  if (!tags.length) {
    return null;
  }

  return (
    <div>
      <Responsive desktop>
        <UIHeading4>Найти отзыв по теме</UIHeading4>
      </Responsive>

      <RatingTagsSlider>
        {tags.map(({ type, title, count, isSelected }) => {
          return (
            <RatingTagItem
              key={type}
              type={type}
              title={title}
              count={count}
              isSelected={isSelected}
              onClick={onClick}
            />
          );
        })}
      </RatingTagsSlider>
    </div>
  );
};
